/* eslint-disable no-unused-vars */
import {
  takeLatest, all, put, call, select,
} from 'redux-saga/effects';
import API from '../../api';
import {
  sendMessageSuccess,
  sendMessageFail,
} from './actions';
import { makeSelectWebhook } from './selectors';
import {
  SEND_MESSAGE,
} from './constants';

const api = API.create();

export function* sendMessage(action) {
  try {
    const { data } = action;

    const webhook = yield select(makeSelectWebhook());

    const result = yield call(api.message.send, { webhook, data });
    if (result.ok) {
      yield put(sendMessageSuccess(result.data));
    } else {
      yield put(sendMessageFail(result.originalError));
    }
  } catch (err) {
    yield put(sendMessageFail(err));
  }
}

export function* sendMessageWithoutAction(data) {
  try {
    const webhook = yield select(makeSelectWebhook());
    const result = yield call(api.message.send, { webhook, data });
    return result;
  } catch (err) {
    return err;
  }
}

export default function* messageSaga() {
  yield all([
    takeLatest(SEND_MESSAGE, sendMessage),
  ]);
}
